import CustomDrawer, { CustomDrawerProps } from "components/custom-drawer/CustomDrawer";
import useCustomDrawer from "hooks/useCustomDrawer";
import { createContext, ReactNode } from "react";

export interface CustomDrawerContextProps {
  showDrawer: (props: Omit<CustomDrawerProps, "open">) => void;
  hideDrawer: () => void;
  drawerProps: CustomDrawerProps;
}

export const CustomDrawerContext = createContext<CustomDrawerContextProps>({
  showDrawer: (props) => {},
  hideDrawer: () => {},
  drawerProps: { open: false, onClose: () => {}, heading: "", headingComponent:<></>, children: <></> },
});

export const CustomDrawerProvider = ({ children }: { children: ReactNode }) => {
  const { showDrawer, hideDrawer, drawerProps } = useCustomDrawer();

  return (
    <CustomDrawerContext.Provider value={{ showDrawer, hideDrawer, drawerProps }}>
      {children}
      <CustomDrawer
        open={drawerProps.open}
        onClose={drawerProps.onClose}
        heading={drawerProps.heading}
        headingComponent={drawerProps.headingComponent}
        children={drawerProps.children}
        width={drawerProps.width}
      />
    </CustomDrawerContext.Provider>
  );
};
